import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IContactGroup } from 'contacts/types';
import { Button, IButtonProps } from 'core/components';
import { useAgGridServerTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

import { ManageEmailDomainsForm } from './ManageEmailDomainsForm';

interface IProps extends IButtonProps {
  contactGroup?: IContactGroup;
}

export const ManageEmailDomainsButton = ({ contactGroup, ...rest }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { selectedRows, updateRows } = useAgGridServerTableContext();

  const isDisabled = !contactGroup && selectedRows.length !== 1;

  const onSubmitSuccess = (updatedContactGroup: IContactGroup) =>
    updateRows({ update: [updatedContactGroup] });

  return (
    <>
      <Button
        text={t('buttonLabelManageEmailDomains')}
        color={Color.PRIMARY}
        variant={isDisabled ? Variant.OUTLINED : Variant.SOLID}
        onClick={() => setIsOpen(true)}
        disabled={isDisabled}
        {...rest}
      />

      <ManageEmailDomainsForm
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSubmitSuccess}
        contactGroup={contactGroup || (selectedRows[0] as IContactGroup)}
      />
    </>
  );
};
